import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoutePlanElement } from 'src/app/models/route';
import { ChargeState } from 'src/app/models/charge-state';
import { LanguageService } from 'src/app/services/account/language.service';

@Component({
  standalone: true,
  selector: 'app-navigation-plan-charge-state',
  templateUrl: './navigation-plan-charge-state.component.html',
  styleUrls: ['./navigation-plan-charge-state.component.scss'],
  imports: [CommonModule]
})
export class NavigationPlanChargeStateComponent {
  @Input() arrivedAtMessage: string = '';
  @Input() arrivedChargerDetails: RoutePlanElement | null = null;
  @Input() chargeTime: string = '';
  @Input() chargeState: ChargeState = ChargeState.None;
  @Input() arrivedChargerIsEndpoint: boolean = false;

  @Output() startChargeClick = new EventEmitter<void>();
  @Output() replanNavigationClick = new EventEmitter<void>();
  @Output() stopNavigationClick = new EventEmitter<void>();
  @Output() finishChargeClick = new EventEmitter<void>();

  public ChargeState = ChargeState;

  get chargeTimeParts(): { text: string; isUnit: boolean }[] {
    if (!this.chargeTime) return [];
    const hourUnit = this.languageService.languageJSON?.Unit_Hour_Short ?? '';
    const minUnit = this.languageService.languageJSON?.Unit_Minute_Short ?? '';
    const units = [hourUnit, minUnit].filter(Boolean);
    if (!units.length) return [{ text: this.chargeTime, isUnit: false }];
    const escaped = units.map(u => u.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`));
    const tokens = this.chargeTime.split(new RegExp(`(${escaped.join('|')})`));
    return tokens.filter(Boolean).map(t => ({ text: t, isUnit: units.includes(t) }));
  }

  constructor(public languageService: LanguageService) {}

  public onStartCharge(): void {
    this.startChargeClick.emit();
  }

  public onReplanNavigation(): void {
    this.replanNavigationClick.emit();
  }

  public onStopNavigation(): void {
    this.stopNavigationClick.emit();
  }

  public onFinishCharge(): void {
    this.finishChargeClick.emit();
  }
}
